import { attachLocale } from '../../../../lib/utils';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';
import { getNavigationCategoriesBarAnalytics } from './navigationCategoriesBarAnalytics';

export const getMoreDropdownEntryProps = ({ analyticsSlug, url, locale }) => {
  const track = getNavigationCategoriesBarAnalytics({
    analyticsSlug,
    url: attachLocale(url, locale),
  });

  return {
    id: track.dataTrackingId,
    'data-track-id': track.dataTrackingId,
    'data-track-click': track.dataTrack,
    'data-track-type': DATA_TRACK_TYPE_INTERNAL,
    href: track.url,
  };
};
